// Module
var code = "<div id=\"content\">\n    <p>상위 단어의 출현 빈도수를 그래프로 보여줍니다.</p>\n</div>";
// Exports
module.exports = code;